import { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Navbar';
import Table from 'react-bootstrap/Table';
import Amplify, { Storage } from 'aws-amplify';
import awsConfig from '../aws-exports';
Amplify.configure(awsConfig);

export const CollectionProductsPage = () => {
  const { collection } = useParams();
  const [ products, setProducts ] = useState([]);
  const [ loading, setLoading ] = useState(true);
  const history = useHistory(); // for routing
  
  useEffect(() => {
    // XXX: get the list of products for this collection
    Storage.get(`p/${collection}/products.json`, {
      download: true,
      cacheControl: 'no-cache',
    })
      .then((res) => {
        res.Body.text().then((resText) => {
          const products = JSON.parse(resText);
          setProducts(products);
          setLoading(false);
        });
      })
      .catch((err) => {
        console.warn(err);
        setLoading(false);
      });
  }, [collection]);

  return (
    <Container fluid className="px-0 px-sm-1">
      <Row className="px-0 px-sm-3">
        <Col className="px-0 px-sm-3">
          <Breadcrumb>
            <Breadcrumb.Item active>{collection.toUpperCase()}</Breadcrumb.Item>
          </Breadcrumb>
          <Table size="sm" hover striped>
            <thead>
              <tr>
                <th className="pl-3">Name</th>
                <th>Product Type</th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td className="pl-3">Loading...</td>
                </tr>
              ) : (
                products?.productTypes?.map(function (productType) {
                  return (
                    <tr
                      key={productType}
                      className="product-list-row"
                      onClick={() =>
                        history.push(`/products/${collection}/${productType}`)
                      }
                    >
                      <td className="pl-3">{collection.toUpperCase()}</td>
                      <td>{productType.toUpperCase()}</td>
                      <td>{products[productType]?.productSKUs.length}</td>
                      <td></td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );
}
